import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { prjectMgm, auditBaseUrl } from '../endpoints';
// Define a service using a base URL and expected endpoints
  export const projectUserMasterService = createApi({
    reducerPath: 'projectUserMasterService',
    baseQuery: fetchBaseQuery({ baseUrl: auditBaseUrl }),
    tagTypes: ['ProjectUserMaster'],
    endpoints: (builder) => ({
        getAllProjectUserMaster: builder.mutation({
            query(body) {
                return {
                    url: `${prjectMgm.projectUserMasterController.getAllProjectUserMaster}/${body.payload.page}/${body.payload.size}?orderBy=${body.payload.orderBy}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}`},
                }
            }
        }),
        getProjectUserMasterById: builder.mutation({
            query(body) {
                return {
                    url: `${prjectMgm.projectUserMasterController.getProjectUserMasterById}/${body.id}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}`},
                }
            }
        }),
        saveProjectUserMaster: builder.mutation({
            query(body){
                return {
                    url: `${prjectMgm.projectUserMasterController.saveProjectUserMaster}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}`},
                    body: body.payload,
                }
            }
        }),
        updateProjectUserMaster: builder.mutation({
            query(body){
                return {
                    url: `${prjectMgm.projectUserMasterController.updateProjectUserMaster}/${body.id}`,
                    method: 'PUT',
                    headers: { Authorization: `Bearer ${body.token}`},
                    body: body.payload,
                }
            }
        }),
        deleteProjectUserMaster: builder.mutation({
            query(body){
                return {
                    url: `${prjectMgm.projectUserMasterController.deleteProjectUserMaster}/${body.id}`,
                    method: 'DELETE',
                    headers: { Authorization: `Bearer ${body.token}`},
                }
            }
        }),
        getAllProjectUserMasterWithSearch: builder.mutation({
            query(body) {
                return {
                    url: `${prjectMgm.projectUserMasterController.getAllProjectUserMasterWithSearch}`,
                    method: "POST",
                    headers: { Authorization: `Bearer ${body.token}`},
                    body: body.payload,
                };
            },
        }),
        findAllProjectUserMaster: builder.mutation({
            query(body) {
                return {
                    url: `${prjectMgm.projectUserMasterController.findAllProjectUserMaster}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}`},
                }
            }
        }),
    })
  });
  export const {
    useGetAllProjectUserMasterMutation,
    useSaveProjectUserMasterMutation,
    useUpdateProjectUserMasterMutation,
    useDeleteProjectUserMasterMutation,
    useGetProjectUserMasterByIdMutation,
    useGetAllProjectUserMasterWithSearchMutation,
    useFindAllProjectUserMasterMutation,
  } = projectUserMasterService;